/**
 * Simple delay function
 * @param data
 * @param delay
 * @returns
 */
export function delay(data: any, delay: number): Promise<any> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, delay);
  });
}
